<template>
  <v-row>
    <v-dialog v-model="showDialog" scrollable max-width="1150px" max-height="90%">
      <v-card>
        <v-card-title style="padding: 5px 0 0 5px;">
          <v-col cols="12">
						<span style="font-size: 20px;">
							{{ !data || !data.id ? $t('wkt.admin.customers.window.new_customer') : $t('wkt.admin.customers.window.edit_customer') }}
						</span>
            <!--<v-btn icon style="top: -20px; left: 10px; float: right;">
              <v-icon @click="showDialog=false">close</v-icon>
            </v-btn>-->
					</v-col>          
        </v-card-title>
				<v-divider></v-divider>
        <v-card-text style="padding-bottom: 0;">
					<v-container>
            <v-tabs
            v-model="tab" 
						centered
						grow>
              <v-tab>
								{{ $t('wkt.admin.customers.window.tab-data.title').toUpperCase() }}
              </v-tab>
              <v-tab>
								{{ $t('wkt.admin.customers.window.tab-translations.title').toUpperCase() }}
              </v-tab>
              <v-tab>
								{{ $t('wkt.admin.customers.window.tab-advanced.title').toUpperCase() }}
              </v-tab>
            </v-tabs> 
						<v-tabs-items v-model="tab">
							<v-tab-item eager> 
								<v-form ref="form1">
									<v-row style="margin-top: 20px;">
										<v-col cols="6">
											<v-autocomplete
												v-model="country"
												:items="countries"
												item-text="name"
												item-value="id"
												menu-props="bottom, offsetY"
												:label="$t('wkt.admin.customers.window.countries_placeholder')"
												return-object
												@change="updateCountry()" />
										</v-col>
										<v-col cols="6">
											<v-autocomplete
												v-model="data.partnerId"
												:items="partners" 
												item-text="name"
												item-value="id"
												menu-props="bottom, offsetY"
												label="Partners" />
										</v-col>
									</v-row>
									<v-row style="margin-top: 20px;">
										<v-col cols="6">                
											<v-text-field
												v-model="data.cif"
												:label="$t('wkt.admin.customers.window.tax_id_number')"
												:placeholder="cifPlaceholder"
												autocomplete="none"
												:rules="[validationRules.required, validationRules.cifnif(data.cif, country)]"
												max="200" />
										</v-col>
										<v-col cols="6">                
											<v-text-field
												v-model="data.emailReport"
												:label="$t('wkt.admin.gconfig.email_report')"
												autocomplete="none"
												:rules="[validationRules.required, validationRules.email]"
												max="200" />
										</v-col>
									</v-row>
									<v-row style="margin-top: 20px;">
										<v-col cols="6">                
											<v-text-field
												v-model="data.emailGdpr"
												:label="$t('wkt.admin.gconfig.email_gdpr')"
												autocomplete="none"
												:rules="[validationRules.required, validationRules.email]"
												max="200" />
										</v-col>
										<v-col cols="6">                
											<v-text-field
												v-model="data.emailSuggestions"
												:label="$t('wkt.admin.customers.window.email_suggestions')"
												autocomplete="none"
												:rules="[validationRules.required, validationRules.email]"
												max="200" />
										</v-col>
									</v-row>
									<v-row style="margin-top: 20px;">
										<v-col cols="6">                
											<v-text-field
												v-model="data.name"
												:label="$t('wkt.admin.customers.window.name')"
												autocomplete="none"
												:rules="[validationRules.required]"
												max="200" />
										</v-col>
										<v-col cols="6">                
											<v-text-field
												v-model="data.address"
												:label="$t('wkt.admin.customers.window.address')"
												autocomplete="none"
												:rules="[validationRules.required]"
												max="200" />
										</v-col>
									</v-row>
									<v-row style="margin-top: 20px;">
										<v-col cols="6">                
											<v-text-field
												v-model="data.postalCode"
												:label="$t('wkt.admin.customers.window.postal_code')"
												:placeholder="postalCodePlaceholder"
												autocomplete="none"
												:rules="[validationRules.required, validationRules.cp(data.postalCode, country)]"
												max="200" />
										</v-col>
										<v-col cols="6">                
											<v-text-field
												v-model="data.location"
												:label="$t('wkt.admin.customers.window.town')"
												autocomplete="none"
												:rules="[validationRules.required]"
												max="200" />
										</v-col>
									</v-row>
									<v-row style="margin-top: 20px;">
										<v-col cols="6">                
											<v-text-field
												v-model="data.telephoneContact"
												:label="$t('wkt.admin.customers.window.contact_phone')"
												:placeholder="phonePlaceholder"
												autocomplete="none"
												:rules="[validationRules.required, validationRules.phone(data.telephoneContact, country)]"
												max="200" />
										</v-col>
										<v-col cols="6">                
											<v-text-field
												:value="formatLongDateTime(data.creationDate)"
												:label="$t('wkt.admin.customers.window.creation_date')"
												autocomplete="none"
												disabled
												:rules="[]"/>
										</v-col>													
									</v-row>
								</v-form>
							</v-tab-item>
							<v-tab-item eager>
								<v-form ref="form2">
									<v-row style="margin-top: 20px;">
										<v-col cols="12">                
											<v-textarea
												v-model="data.customLocalization"
												autocomplete="none"
												:rules="[validationRules.json]" />
										</v-col>														
									</v-row>
								</v-form>
							</v-tab-item>
							<v-tab-item eager>
								<v-form ref="form3">
									<v-row style="margin-top: 20px;">
										<v-col cols="6" class="pb-0">  
                                                         <v-switch
                                                               v-model="data.licenseEnabled"
                                                               flat
                                                               :label="$t('wkt.admin.customers.window.license_enabled')"
                                                            ></v-switch>
                                        </v-col>
										<v-col cols="6" class="pb-0">  
                                                         <v-switch
                                                               v-model="data.moduleAIEnabled"
                                                               flat
                                                               :label="$t('wkt.admin.customers.window.ai_module')"
                                                            ></v-switch>
                                        </v-col>			
										<v-col cols="6" class="pb-0">  
                                                         <v-switch
                                                               v-model="data.moduleSupportEnabled"
                                                               flat
                                                               :label="$t('wkt.admin.customers.window.support_module')"
                                                            ></v-switch>
                                        </v-col>
										<v-col cols="6" class="pb-0">  
                                                         <v-switch
                                                               v-model="data.moduleDocumentsExternalEnabled"
                                                               flat
                                                               :label="$t('wkt.admin.customers.window.external_documents_module')"
                                                            ></v-switch>
                                        </v-col>	
										<v-col cols="6" class="pb-0">  
                                                         <v-switch
                                                               v-model="data.enableAdvancedPlanning"
                                                               flat
                                                               :label="$t('wkt.admin.customers.window.enable_advanced_planning')"
                                                            ></v-switch>
                                        </v-col>
										<!-- sw Habilitar fichaje avanzado -->
										<v-col cols="6" class="pb-0">  
                                                         <v-switch
                                                               v-model="data.enableAdvancedCheckin"
                                                               flat
                                                               :label="$t('wkt.admin.customers.window.enable_advanced_checkin')"
                                                            ></v-switch>
                                        </v-col>
										<!-- sw Habilitar vacaciones avanzadas -->
										<v-col cols="6" class="pb-0">  
                                                         <v-switch
                                                               v-model="data.enableAdvancedVacation"
                                                               flat
                                                               :label="$t('wkt.admin.customers.window.enable_advanced_vacation')"
                                                            ></v-switch>
                                        </v-col>
									</v-row>

									<v-row style="margin-top: 20px;">
										<v-col cols="6">                
											<v-text-field
												v-model="data.apiRateLimit"
												:label="$t('wkt.admin.customers.window.api_rate_limit')"
												autocomplete="none"
												:rules="[validationRules.required]"
												type="number"/>
										</v-col>	
										<v-col cols="6">                
											<v-text-field
												v-model="data.notes"
												:label="$t('wkt.admin.customers.window.notes')"
												autocomplete="none"
												type="Label"
												hint="Notas"
												/>
										</v-col>									
									</v-row>
								</v-form>
							</v-tab-item>
						</v-tabs-items>
					</v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn v-if="showDeleteButton" color="#ff0000" @click="confirmDelete()">
						<v-icon left color="#ffffff">delete</v-icon>
						<span style="color: #ffffff;">{{ $t('wkt.admin.common.dialog-buttons.delete').toUpperCase() }}</span>
					</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="#185EA9" text @click="ok()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.ok').toUpperCase() }}</v-btn>
          <v-btn text @click="showDialog=false" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
        </v-card-actions>
      </v-card>
			<LoadingDialog :loading="loading" />
    </v-dialog>

		<ConfirmDialog ref="dlgConfirm"
			v-bind:title="$t('wkt.admin.customers.window.delete_title')"
			v-bind:message="$t('wkt.admin.customers.window.delete_msg')"
			v-bind:titleOk="$t('wkt.admin.common.dialog-buttons.delete')"
			v-bind:titleCancel="$t('wkt.admin.common.dialog-buttons.cancel')"
			v-on:confirmed="confirmDeleteItem()"
		/>
		
		<DeleteCustomerDialog ref="dlgDeleteCustomer"/>

  </v-row>	
</template>

<script>
import BaseModule from '../common/BaseModule.js'
import ConfirmDialog from '../common/ConfirmDialog'
import DeleteCustomerDialog from './DeleteCustomerDialog'
import LoadingDialog from '../common/LoadingDialog'
import api from '../../api/worktime'
import gwt from '../../api/gwt'

export default {
	name: 'CustomersDialog',
	mixins: [BaseModule],
	components: {
		ConfirmDialog, DeleteCustomerDialog, LoadingDialog
	},
	data () {
		return {
			showDialog: false,
			loading: false,
			tab: 0,
			countries: [],
			country: null,
			partners: [],
			companyPartners: [],
			data: {},
			cifPlaceholder: null,
			phonePlaceholder: null,
			postalCodePlaceholder: null,
			msgCb: null,
			showDeleteButton: false,
			validationRules: {
				json: v=> !v || this.validateJsonTranslations(v) || window.$vue.$t('wkt.admin.customers.window.invalid_translations_json'),
			},
		}
	},
	methods: {
		buildEmptyData() {
			var data = gwt.newCompany();							
			return data;
		},
		open: function(partners, data, msgCb) {
			if (this.$refs.form1) {
				this.$refs.form1.resetValidation();
			}
			if (this.$refs.form2) {
				this.$refs.form2.resetValidation();
			}

			this.clear();

			this.companyPartners = partners;
      this.data = data;

			this.fillCountriesComboBox();
			this.fillPartnersComboBox();

			if (this.data) {
				this.data = data;
			} else {
				this.data = this.buildEmptyData();
			}

			if (!this.data.customLocalization) {
				this.data.customLocalization = this.buildDefaultJSONTraducciones();
			}

			if (this.data.countryId) {
				this.country = this.countries.find(x => x.id == this.data.countryId);
			}

			// placeholders por pais
			this.cifPlaceholder = gwt.getCompanyPlaceholderCif(this.data.countryId);
			this.phonePlaceholder = gwt.getCompanyPlaceholderTelf(this.data.countryId);
			this.postalCodePlaceholder = gwt.getCompanyPlaceholderCp(this.data.countryId);

			this.msgCb = msgCb;
			this.showDeleteButton = data != null;
			this.showDialog = true;
		},
		clear() {
			this.tab = 0;
			this.country = null;
			this.countries = [];
			this.partners = [];
			this.companyPartners = [];
			this.data = this.buildEmptyData();
		},
		buildDefaultJSONTraducciones() {
			var json = '{\n';
 
			var countries = gwt.getSessionInformation().countries;
			
			var locales = [];
			
			for (var i = 0; i < countries.length; i++) {
				var country = countries[i];
				if (locales.findIndex(x => x == country.locale) == -1) {
					locales.push(country.locale);
				}
			}

			for (var j = 0; j < locales.length; j++) {
				var locale = locales[j];
				json += ` "${locale}": {}`;
				json += j < locales.length - 1 ? ',\n' : '\n';
			}

			json += '}';

			return json;
		},
		fillCountriesComboBox() {
			this.countries = [];

			this.countries.push({ id: null, name: this.$t('wkt.admin.common.select_country') });

			for (var i = 0; i < gwt.getSessionInformation().countries.length; i++) {
				var country = gwt.getSessionInformation().countries[i];
				this.countries.push({ id: country.id, name: this.$t(country.name), locale: country.locale, phonePrefixCode: country.phonePrefixCode });
			}
		},
		fillPartnersComboBox() {
			this.partners = [];

			this.partners.push({ id: null, name: `-- ${this.$t('wkt.admin.common.no_partner')} --` });

			for (var i = 0; i < this.companyPartners.length; i++) {
				var partner = this.companyPartners[i];
				this.partners.push({ id: partner.id, name: partner.companyName });
			}
		},
		updateCountry() {			
			this.data.countryId = this.country.id;
			this.cifPlaceholder = gwt.getCompanyPlaceholderCif(this.data.countryId);
			this.phonePlaceholder = gwt.getCompanyPlaceholderTelf(this.data.countryId);
			this.postalCodePlaceholder = gwt.getCompanyPlaceholderCp(this.data.countryId);
		},
		validateJsonTranslations(json) {
			return this.validateJson(json);
		},
		validate() {
			var isValid = true;

			if (isValid && !this.$refs.form1.validate()) {
				if (this.tab != 0) {
					this.tab = 0;
				}
				isValid = false;
			}

			if (isValid && !this.$refs.form2.validate()) {
				if (this.tab != 1) {
					this.tab = 1;
				}
				isValid = false;
			}

			if (isValid && !this.$refs.form3.validate()) {
				if (this.tab != 2) {
					this.tab = 2;
				}
				isValid = false;
			}

			return isValid;
		},
		ok: function() {
			if (!this.validate()) {
				return;
			}

			if (this.data.telephoneContact && this.data.telephoneContact.indexOf(`+${this.country.phonePrefixCode}`) == -1) {
				this.data.telephoneContact = `+${this.country.phonePrefixCode}${this.data.telephoneContact}`;
			}

			if (!this.data.id) {
				this.data.creationDate = new Date().getTime();
			}

			this.data.locale = this.country.locale;

			if (!this.data.customLocalization || this.data.customLocalization.indexOf('wkt.') == -1) {
				this.data.customLocalization = null;
			}

			this.loading = true;

			api.storeCompany(this.data,
				res => {
					this.loading = false;
					this.showDialog = false;
					if (this.msgCb) {
						if (res.rsOK && !res.message) {
							res.message = `La empresa se ${!this.data.id ? 'ha creado' : 'ha actualizado'} correctamente`;
						}
						this.msgCb(res.message, res.rsOK);
					}
				},
				error => {
					this.loading = false;
					this.$log.error(error);
					if (this.msgCb) {
						this.msgCb(error.message, false);
					}
				});
		},
		confirmDelete() {
			this.$refs.dlgConfirm.confirm(this.data);
		},
		confirmDeleteItem() {
			this.$refs.dlgDeleteCustomer.open(this.data, this.country, () => this.deleteItem());
		},
		deleteItem() {	
			this.loading = true;	

			api.deleteCompany(this.data.id,
				res => {
					this.loading = false;
					this.showDialog = false;
			
					if (res == -1) {
						if (this.msgCb) {
							this.msgCb(this.$t('wkt.admin.customers.window.unable_delete_customer_error'), false);
						}
						return;
					}

					if (this.msgCb) {
						this.msgCb('Se ha planificado correctamente el borrado de la empresa', true);
					}
				},
				(error) => {
					this.loading = false;
					this.$log.error(error);
					if (this.msgCb) {
						this.msgCb(error.message, false);
					}
				}
			);
		},

	},
}
</script>